import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LTCurrentStatusToggleComponent } from './components/lt-current-status-toggle/lt-current-status-toggle';
import { LTErrorBulkUpdateDialogComponent } from './components/lt-error-bulk-update-dialog/lt-error-bulk-update-dialog';
import { LTErrorDetailViewComponent } from './components/lt-error-detail-view/lt-error-detail-view';
import { LTErrorUpdateDialogComponent } from './components/lt-error-update-dialog/lt-error-update-dialog';
import { BasicErrorSearchFilterComponent } from './components/basic-error-search-filter/basic-error-search-filter.component';
import { ReportErrorSearchFilterComponent } from './components/report-error-search-filter/report-error-search-filter.component';
import { LTErrorsGridComponent } from './components/lt-errors-grid/lt-errors-grid';
import { LTServiceErrorsGridComponent } from './components/lt-service-errors-grid/lt-service-errors-grid.component';
@NgModule({
  imports: [
    CommonModule,
    BasicErrorSearchFilterComponent,
    ReportErrorSearchFilterComponent,
    LTCurrentStatusToggleComponent,
    LTErrorBulkUpdateDialogComponent,
    LTErrorUpdateDialogComponent,
    LTErrorDetailViewComponent,
    LTErrorsGridComponent,
    LTServiceErrorsGridComponent,
  ],
  exports: [
    BasicErrorSearchFilterComponent,
    ReportErrorSearchFilterComponent,
    LTCurrentStatusToggleComponent,
    LTErrorBulkUpdateDialogComponent,
    LTErrorUpdateDialogComponent,
    LTErrorDetailViewComponent,
    LTErrorsGridComponent,
    LTServiceErrorsGridComponent,
  ],
})
export class LTErrorsModule { }